export default {
    // 门户
    "threeWeb":'https://www.zengcaicloud.com',
    // 买家中心
    "buyerWeb":'https://buyer.zengcaicloud.com',
    // 设计师中心
    "designerWeb":'https://designer.zengcaicloud.com',

}



// WEBPACK FOOTER //
// ./src/utils/url.js